import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/ui/spinner";

interface ReauthenticationModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentPassword: string;
  setCurrentPassword: (password: string) => void;
  onConfirm: () => void;
  reauthError: string;
  isLoading?: boolean;
}

export const ReauthenticationModal = ({
  isOpen,
  onClose,
  currentPassword,
  setCurrentPassword,
  onConfirm,
  reauthError,
  isLoading = false
}: ReauthenticationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && onClose()}>
      <DialogContent
        className="sm:max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Confirm Your Current Password</DialogTitle>
          <DialogDescription>
            To change your password, please enter your current password for
            security verification.
          </DialogDescription>
        </DialogHeader>
        <form
          className="grid gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (currentPassword.trim()) onConfirm();
          }}
        >
          <Label htmlFor="reauth-password">Current password</Label>
          <Input
            id="reauth-password"
            type="password"
            autoFocus
            placeholder="Enter your current password"
            value={currentPassword}
            aria-invalid={!!reauthError}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          {reauthError ? (
            <p className="text-sm text-destructive">{reauthError}</p>
          ) : null}
          <DialogFooter className="mt-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading || !currentPassword.trim()}
            >
              {isLoading ? <Spinner /> : null} Confirm
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
